export default "__VITE_ASSET__BWDjuXnE__"